import z from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { encodedSignUpDataSchema } from './sign-up.models';

export const USER_SIGN_IN_TYPE = 'user/sign-in';

// also the native sign-in's role vocabulary — asking for a role is the same whichever way
// the caller authenticates
export const roleSchema = z.enum(['clinician']);
export type Role = z.infer<typeof roleSchema>;

export const userSignIn = defineCommand(
    USER_SIGN_IN_TYPE,
    z.object({
        siteUrl: z.url(),
        returnUrl: z.url().optional(),
        // Not piped through roleSchema: the admin plane also sends this command its own role,
        // outside roleSchema's vocabulary. SignIn validates against its injected allowed roles.
        role: z.string().meta(metadata.nonSensitive),
        signUpData: encodedSignUpDataSchema.optional(),
    }),
    z.object({ url: z.url() }),
);

export const USER_HANDLE_CALLBACK_TYPE = 'user/handle-callback';

// Both planes reuse this contract directly and hand the callback back the same shape,
// finalizing-token or established session.
export const handleCallbackOutput = z.discriminatedUnion('mode', [
    z.object({
        mode: z.literal('session'),
        sessionId: z.string(),
        maxAge: z.number(),
        returnUrl: z.url().optional(),
    }),
    z.object({
        mode: z.literal('token'),
        signInToken: z.string(),
        maxAge: z.number(),
        returnUrl: z.url().optional(),
    }),
]);

export const userHandleCallback = defineCommand(
    USER_HANDLE_CALLBACK_TYPE,
    z.object({
        code: z.string().optional(),
        state: z.string(),
    }),
    handleCallbackOutput,
);
